import React from 'react';

import { CarDocType } from '@/modules/car/model';
import {
  carUploadSlice,
  carUploadAsyncActions,
  carUploadSelectors,
} from '@/modules/car/store/upload-slice';
import { DriverDocType } from '@/modules/driver/model/driver-doc-type';
import {
  driverUploadSlice,
  driverUploadAsyncActions,
  driverUploadSelectors,
  myDriverUploadSlice,
  myDriverUploadAsyncActions,
  myDriverUploadSelectors,
} from '@/modules/driver/store/upload-slice';
import { PartnerDocType } from '@/modules/partner/model/partner-doc-type';
import {
  partnerUploadSlice,
  partnerUploadAsyncActions,
  partnerUploadSelectors,
} from '@/modules/partner/store/uploadSlice';

import { ConnectedUpload, IConnectedUploadProps } from './connected-upload';

type IProps<T extends string> = Pick<
  IConnectedUploadProps<T>,
  'onClickSkip' | 'onFinishUpload' | 'onUploaded'
>;

const UploadCar = React.memo((props: IProps<CarDocType>) => (
  <ConnectedUpload<CarDocType>
    onUpdateForm={carUploadSlice.actions.updateUploadFormValue}
    onSubmitForms={carUploadAsyncActions.submitUploadForms}
    selectUploadForm={carUploadSelectors.getUploadForm}
    selectUploadDefinition={carUploadSelectors.getUploadDefinition}
    selectDocDefinitions={carUploadSelectors.getDocDefinitions}
    selectUploadedDocs={carUploadSelectors.getUploadedDocs}
    selectHolderId={carUploadSelectors.getHolderId}
    onClickSkip={props.onClickSkip}
    onFinishUpload={props.onFinishUpload}
    onUploaded={props.onUploaded}
    scope="car"
  />
));

UploadCar.displayName = 'UploadCar';

const UploadDriver = React.memo((props: IProps<DriverDocType>) => (
  <ConnectedUpload<DriverDocType>
    onUpdateForm={driverUploadSlice.actions.updateUploadFormValue}
    onSubmitForms={driverUploadAsyncActions.submitUploadForms}
    selectUploadForm={driverUploadSelectors.getUploadForm}
    selectUploadDefinition={driverUploadSelectors.getUploadDefinition}
    selectDocDefinitions={driverUploadSelectors.getDocDefinitions}
    selectUploadedDocs={driverUploadSelectors.getUploadedDocs}
    selectHolderId={driverUploadSelectors.getHolderId}
    onClickSkip={props.onClickSkip}
    onFinishUpload={props.onFinishUpload}
    onUploaded={props.onUploaded}
    scope="driver"
  />
));

UploadDriver.displayName = 'UploadDriver';

const UploadMyDriver = React.memo((props: IProps<DriverDocType>) => (
  <ConnectedUpload<DriverDocType>
    onUpdateForm={myDriverUploadSlice.actions.updateUploadFormValue}
    onSubmitForms={myDriverUploadAsyncActions.submitUploadForms}
    selectUploadForm={myDriverUploadSelectors.getUploadForm}
    selectUploadDefinition={myDriverUploadSelectors.getUploadDefinition}
    selectDocDefinitions={myDriverUploadSelectors.getDocDefinitions}
    selectUploadedDocs={myDriverUploadSelectors.getUploadedDocs}
    selectHolderId={myDriverUploadSelectors.getHolderId}
    onClickSkip={props.onClickSkip}
    onFinishUpload={props.onFinishUpload}
    onUploaded={props.onUploaded}
    scope="myDriver"
  />
));

UploadMyDriver.displayName = 'UploadMyDriver';

const UploadPartner = React.memo((props: IProps<PartnerDocType>) => (
  <ConnectedUpload<PartnerDocType>
    onUpdateForm={partnerUploadSlice.actions.updateUploadFormValue}
    onSubmitForms={partnerUploadAsyncActions.submitUploadForms}
    selectUploadForm={partnerUploadSelectors.getUploadForm}
    selectUploadDefinition={partnerUploadSelectors.getUploadDefinition}
    selectDocDefinitions={partnerUploadSelectors.getDocDefinitions}
    selectUploadedDocs={partnerUploadSelectors.getUploadedDocs}
    selectHolderId={partnerUploadSelectors.getHolderId}
    onClickSkip={props.onClickSkip}
    onFinishUpload={props.onFinishUpload}
    onUploaded={props.onUploaded}
  />
));

UploadPartner.displayName = 'UploadPartner';

export { UploadCar, UploadDriver, UploadMyDriver, UploadPartner };
